/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 
jQuery(document).ready(function($){
  
   $('.product__slider-for').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     arrows: true,
     fade: true,
     asNavFor: '.product__slider-nav'
   });
  
   $('.product__slider-nav').slick({
     slidesToShow: 5,
     slidesToScroll: 1,
     asNavFor: '.product__slider-for',
     dots: false,
     arrows: true,
     prevArrow: '<button type="button" class="prev_slicks"><i class="fa fa-angle-up"></i></button>',
     nextArrow: '<button type="button" class="next_slicks"><i class="fa fa-angle-down"></i></button>',
     vertical: true,
     infinite: false,
     // prevArrow: $('.prev'),
     // nextArrow: $('.next'),
     focusOnSelect: true,
     responsive: [{
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
      }
     },{
      breakpoint: 577,
      settings: {
        vertical: false,
        slidesToShow: 4,
      }
     },{
      breakpoint: 480,
      settings: {
        vertical: false,
        slidesToShow: 4,
      }
     },{
      breakpoint: 360,
      settings: {
        vertical: false,
        slidesToShow: 3,
      }
     }]
   });

  // FAQ's Active Classes
  $('.accordian_list').on('click','.accordian_list_head', function(e){
    e.preventDefault();
    if($(this).parent('.accordian_list').hasClass('accordian_list_active')){
      $(this).parent('.accordian_list').removeClass('accordian_list_active');
      $(this).siblings('.accordian_answer').slideToggle('medium','linear');
    } else {
      $(this).parent('.accordian_list').addClass('accordian_list_active');
      $(this).siblings('.accordian_answer').slideToggle('medium','linear');
      $(this).parent('.accordian_list').siblings('.accordian_list_active').find('.accordian_answer').slideToggle('medium','linear');
      $(this).parent('.accordian_list').siblings('.accordian_list_active').removeClass('accordian_list_active');
    }
  });
  
  if($('body').find('.Product__InfoWrapper').length !== 0) {
    var infos_height = $('.Product__InfoWrapper').height();
    var title_height = $('.nd_product_titles').height();
    console.log(infos_height +' -> '+title_height);
    $('.Product__InfoWrapper').css('margin-top',title_height + 30);
    $('.Product__Wrapper').height(infos_height + title_height + 140);
    //console.log(infos_height +' -> '+ title_height +' -> '+ 120);
  }
  
   $('.model_slider_img').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     dots: false,
     arrows: true,
     prevArrow: '<button type="button" class="prev_slicks"><i class="fa fa-angle-left"></i></button>',
     nextArrow: '<button type="button" class="next_slicks"><i class="fa fa-angle-right"></i></button>',
     infinite: false,
     focusOnSelect: true,
     asNavFor: '.model_slider_thumbnails',
     responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: false
      }
     }]
   });
  
  $('.model_slider_thumbnails').slick({
    autoplay: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.model_slider_img',
    dots: true,
    focusOnSelect: true,
    variableWidth: true
  });
  $('.glider_like').slick({
     slidesToShow: 3,
     slidesToScroll: 3,
     dots: true,
     arrows: true,
     prevArrow: '<button type="button" class="prev_slicks"><i class="fa fa-angle-left"></i></button>',
     nextArrow: '<button type="button" class="next_slicks"><i class="fa fa-angle-right"></i></button>',
     infinite: false,
     focusOnSelect: true,
     responsive: [{
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
     }]
   });
  $('.announcement_slider').slick({
    infinite: true,
    arrows: false,
    prevArrow: '<button type="button" class="prev_slicks"><i class="fa fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="next_slicks"><i class="fa fa-angle-right"></i></button>',
    dots: false,
    slidesToShow: 1,
    adaptiveHeight: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000
  });

  //Watch Grid
  $('.rcpo_watch_grid_inner').slick({
    infinite: false,
    arrows: false,
    prevArrow: '<button type="button" class="prev_slicks"><i class="fa fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="next_slicks"><i class="fa fa-angle-right"></i></button>',
    dots: true,
    draggable: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },{
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  //Rolex Modal Page
  var v7_watch_cover_slider = {
    infinite: false,
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick"
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  // Initialize Slick on page load
  $('.v7_watch_cover_slider').slick(v7_watch_cover_slider);
  
  // Reinitialize Slick on window resize
  $(window).resize(function() {
    var windowWidth = $(window).width();
    if(windowWidth >= 768) {
        $('.v7_watch_cover_slider').slick(v7_watch_cover_slider);   // Reinitialize Slick
    } else if(windowWidth < 768) {
        $('.v7_watch_cover_slider').slick(v7_watch_cover_slider);   // Reinitialize Slick
    }
  });

  //Rolex Modal Page Popup
  var v7_watch_popup_slider = $('.v7_watch_popup_slider').slick({
    infinite: false,
    arrows: true,
    prevArrow: '<button type="button" class="prev_slicks"><i class="fa fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="next_slicks"><i class="fa fa-angle-right"></i></button>',
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false
  });

  //Rolex Modal Page Popup Active
  $('.v7_watch_cover_slider').on('click', '.v7_watch_cover_img', function(e){
    e.preventDefault();
    if($(window).width() > 767) {
      var rand_num = $(this).attr('data-rand');
      $('.v7_watch_popup').addClass('v7_watch_popup_active');
      v7_watch_popup_slider.slick('slickGoTo', rand_num);
    }
  });

  //Rolex Modal Page Popup In-Active
  $('.v7_watch_popup').on('click', '.v7_watch_popup_close', function(e){
    e.preventDefault();
    if($(window).width() > 767) {
      $('.v7_watch_popup').removeClass('v7_watch_popup_active');
    }
  });

  //Confirm Click RCPO Collection
  $('.collection_inner').on('click', '.boost-pfs-filter-apply-all-button', function(e){
    e.stopPropagation();
    if($(window).width() < 1025) {
      $('.collection_inner .CollectionToolbar__Item--filter').find('button').trigger('click');
    }
  });

  //RCPO Modal Page Popup
  var rcpo_watch_popup_slider = $('.rcpo_360_popup_slider').slick({
    infinite: false,
    arrows: true,
    prevArrow: '<button type="button" class="prev_slicks"><i class="fa fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="next_slicks"><i class="fa fa-angle-right"></i></button>',
    dots: true,
    draggable: false,
    swipe: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false
  });

  //RCPO Modal Page Popup Active
  $('.rcpo_watch_cover_img').on('click', '.rcpo_360_click', function(e){
    e.preventDefault();
      var rand_num = $(this).attr('data-rand');
      $('.rcpo_360_popup').addClass('rcpo_360_popup_active');
      rcpo_watch_popup_slider.slick('slickGoTo', rand_num);
  });

  //RCPO Modal Page Popup Active
  $('.rcpo_watch_cover_thumb').on('click', '.rcpo_wcover_thumb_img', function(e){
    e.preventDefault();
    if($(window).width() > 767) {
      var rand_num = $(this).attr('data-rand');
      $('.rcpo_360_popup').addClass('rcpo_360_popup_active');
      rcpo_watch_popup_slider.slick('slickGoTo', rand_num);
    }
  });

  //RCPO Modal Page Popup In-Active
  $('body .rcpo_360_popup').on('click', '.rcpo_360_popup_close', function(e){
    e.preventDefault();
    $('.rcpo_360_popup').removeClass('rcpo_360_popup_active');
  });

  $('.rcpo_360_popup').on( 'touchstart', '.rcpo_360_popup_close', function(e){
    e.preventDefault();
    $('.rcpo_360_popup').removeClass('rcpo_360_popup_active');
  });

  //RCPO Main Watch Slider
  $('.rcpo_wcover_slider').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     dots: true,
     arrows: true,
     prevArrow: '<button type="button" class="prev_slicks"><i class="fa fa-angle-left"></i></button>',
     nextArrow: '<button type="button" class="next_slicks"><i class="fa fa-angle-right"></i></button>',
     infinite: true,
     focusOnSelect: true
   });

  $('.click_scroll').click(function(e) {
    e.preventDefault();
      var target = $(this.hash);
        $('html,body').stop().animate({
          scrollTop: target.offset().top - 110
        }, '1500');   
  }); 

  //Video Play on Click
  $('.v7_video_play').click(function(e) {
    e.preventDefault();
    $(this).find('svg').addClass('color_brown');
    var text = $(this).siblings('iframe')[0].src;
    text = text.replace("autoplay=0", "autoplay=1");
    $(this).siblings('iframe').remove();
    $(this).parent('.v7_video_box').append('<iframe allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" src="'+ text +'"></iframe>');
    setTimeout(() => { 
      $(this).siblings('.v7_video_box_overlay').addClass('v7_disp_none');
      $(this).addClass('v7_disp_none');
    }, 1000);
  }); 
  
  $('.v7_watch_cover_btns_phone').on('click', function(e) {
    e.preventDefault();
    if($(this).siblings('.v7_watch_cover_phone_list').hasClass('v7_phone_list_open')){
      $(this).siblings('.v7_watch_cover_phone_list').removeClass('v7_phone_list_open');
      $(this).siblings('.v7_watch_cover_phone_list').slideToggle('slow','linear');
    } else {
      $(this).siblings('.v7_watch_cover_phone_list').addClass('v7_phone_list_open');
      $(this).siblings('.v7_watch_cover_phone_list').slideToggle('slow','linear');
    }
  }); 
  
  $('.rcpo_watch_cover_btns_phone').on('click', function(e) {
    e.preventDefault();
    if($(this).siblings('.rcpo_watch_cover_phone_list').hasClass('rcpo_phone_list_open')){
      $(this).siblings('.rcpo_watch_cover_phone_list').removeClass('rcpo_phone_list_open');
      $(this).siblings('.rcpo_watch_cover_phone_list').slideToggle('medium','linear');
    } else {
      $(this).siblings('.rcpo_watch_cover_phone_list').addClass('rcpo_phone_list_open');
      $(this).siblings('.rcpo_watch_cover_phone_list').slideToggle('medium','linear');
    }
  }); 
  const reset_filter = setInterval(function() {
    //console.log($('.collection_inner').find('.boost-pfs-filter-left-col').length);
    if($('.collection_inner').find('.boost-pfs-filter-left-col').length > 0) {
      $('.collection_inner').find('.boost-pfs-filter-left-col').prepend('<a href="https://www.robertgatwardjewellers.co.uk/collections/rolex-certified-pre-owned-watches" class="boost-reset-js">Reset</a>');
      $('.collection_inner .boost-pfs-filter-left-col').append('<span class="boostfilter-close-js">Confirm</span>');
      clearInterval(reset_filter);
    }
  }, 1000);

  // const confirm_filter = setInterval(function() {
  //   //console.log($('.collection_inner').find('.boost-pfs-filter-left-col').length);
  //   if($('.collection_inner').find('.boost-pfs-filter-left-col .boost-pfs-filter-tree-v').length > 0) {
  //     //console.log($('.collection_inner .boost-pfs-filter-left-col .boost-pfs-filter-mobile-footer').find('.boost-pfs-filter-apply-all-button').length);
  //     $('.collection_inner .boost-pfs-filter-left-col .boost-pfs-filter-tree-v').append('<span class="boostfilter-close-js" style="display:none;">Confirm</span>');
  //     clearInterval(confirm_filter);
  //   }
  // }, 1000);

  $('.collection_inner').on('click', '.boost-reset-js', function(e){
    e.preventDefault();
    $('.boost-pfs-filter-tree-v .boost-pfs-filter-option.boost-pfs-filter-option-view-collection .boost-pfs-filter-option-item-list .boost-pfs-filter-option-item:first-child').trigger('click');
  });

  $('.collection_inner').on('click', '.boost-pfs-filter-clear-all', function(e){
    if (window.location.href.indexOf("rolex-certified-pre-owned-watches") === -1) {
      e.preventDefault();
      $('.boost-pfs-filter-tree-v .boost-pfs-filter-option.boost-pfs-filter-option-view-collection .boost-pfs-filter-option-item-list .boost-pfs-filter-option-item:first-child').trigger('click');
    }
  });

  $('.collection_inner').on('click', '.boostfilter-close-js', function(e){
    e.preventDefault();
    //alert($(this).attr('class'));
    console.log($('.boost-pfs-filter-tree-v .boost-pfs-filter-mobile-toolbar-top .boost-pfs-filter-close').find('span').length);
    $('.boost-pfs-filter-tree-v .boost-pfs-filter-mobile-toolbar-top .boost-pfs-filter-close').find('span').trigger('click');
  });
  
  $('.model_slider_phone_js').on('click', function(e){
    if($(this).siblings('.model_contact_list').hasClass('model_contact_list_open')){
      $(this).siblings('.model_contact_list').removeClass('model_contact_list_open');
      $(this).siblings('.model_contact_list').slideToggle('slow','linear');
    } else {
      $(this).siblings('.model_contact_list').addClass('model_contact_list_open');
      $(this).siblings('.model_contact_list').slideToggle('slow','linear');
    }
  });
  $(document).on('click', function (e) {
    if ($(e.target).closest(".model_contact_list_open").length === 0 && $(e.target).closest(".model_slider_phone_js").length === 0 && $('.model_contact_list').hasClass('model_contact_list_open')) {
      $('.model_contact_list_open').slideToggle('slow','linear');
      $('.model_contact_list_open').removeClass('model_contact_list_open');
    }
  });
  
  //Rolex Modal Contact
  $('.v7_modalcontact_innhead').on('click', function(e){
    if($(this).parents('.v7_modalcontact_box').hasClass('v7_modalcontact_active')){
      $(this).parents('.v7_modalcontact_box').removeClass('v7_modalcontact_active');
      $(this).siblings('.v7_modalcontact_inndata').slideToggle('medium','linear');
    } else {
      $(this).parents('.v7_modalcontact_box').siblings('.v7_modalcontact_active').find('.v7_modalcontact_inndata').slideToggle('medium','linear');
      $(this).parents('.v7_modalcontact_box').siblings('.v7_modalcontact_active').removeClass('v7_modalcontact_active');
      $(this).parents('.v7_modalcontact_box').addClass('v7_modalcontact_active');
      $(this).siblings('.v7_modalcontact_inndata').slideToggle('medium','linear');
    }
  });

  //Rolex Modal Message Buttons
  $('.v7_watch_cover_btns_message, .rcpo_watch_cover_btns_message').on('click', function(e){
    e.preventDefault();
    if($('.v7_modalcontact_message').parents('.v7_modalcontact_box').hasClass('v7_modalcontact_active')){

    } else {
      $('.v7_modalcontact_message').parents('.v7_modalcontact_box').siblings('.v7_modalcontact_active').find('.v7_modalcontact_inndata').slideToggle('medium','linear');
      $('.v7_modalcontact_message').parents('.v7_modalcontact_box').siblings('.v7_modalcontact_active').removeClass('v7_modalcontact_active');
      $('.v7_modalcontact_message').parents('.v7_modalcontact_box').addClass('v7_modalcontact_active');
      $('.v7_modalcontact_message').siblings('.v7_modalcontact_inndata').slideToggle('medium','linear');
    }
    var head_height = $('#section-header').innerHeight();
    var target = $(this.hash);
      $('html,body').stop().animate({
        scrollTop: target.offset().top - head_height + 60
      }, '1500'); 
  });

  //Rolex Modal Appointment Buttons
  $('.rcpo_watch_cover_btns_appointment').on('click', function(e){
    e.preventDefault();
    if($('.v7_modalcontact_appointment').parents('.v7_modalcontact_box').hasClass('v7_modalcontact_active')){

    } else {
      $('.v7_modalcontact_appointment').parents('.v7_modalcontact_box').siblings('.v7_modalcontact_active').find('.v7_modalcontact_inndata').slideToggle('medium','linear');
      $('.v7_modalcontact_appointment').parents('.v7_modalcontact_box').siblings('.v7_modalcontact_active').removeClass('v7_modalcontact_active');
      $('.v7_modalcontact_appointment').parents('.v7_modalcontact_box').addClass('v7_modalcontact_active');
      $('.v7_modalcontact_appointment').siblings('.v7_modalcontact_inndata').slideToggle('medium','linear');
    }
    var head_height = $('#section-header').innerHeight();
    var target = $(this.hash);
      $('html,body').stop().animate({
        scrollTop: target.offset().top - head_height + 60
      }, '1500'); 
  })
  
  //Rolex Modal Accordian
  $('.v7_accordian_head').on('click', function(e){
    if($(this).parents('.v7_accordian_data').hasClass('v7_accordian_active')){
      $(this).parents('.v7_accordian_data').removeClass('v7_accordian_active');
      $(this).siblings('.v7_accordian_para').slideToggle('medium','linear');
    } else {
      $(this).parents('.v7_accordian_data').siblings('.v7_accordian_active').find('.v7_accordian_para').slideToggle('medium','linear');
      $(this).parents('.v7_accordian_data').siblings('.v7_accordian_active').removeClass('v7_accordian_active');
      $(this).parents('.v7_accordian_data').addClass('v7_accordian_active');
      $(this).siblings('.v7_accordian_para').slideToggle('medium','linear');
    }
  });
  
  //RCPO Modal Accordian
  $('.rcpo_accordian_head').on('click', function(e){
    if($(this).parents('.rcpo_accordian_data').hasClass('rcpo_accordian_active')){
      $(this).parents('.rcpo_accordian_data').removeClass('rcpo_accordian_active');
      $(this).siblings('.rcpo_accordian_para').slideToggle('medium','linear');
    } else {
      $(this).parents('.rcpo_accordian_data').siblings('.rcpo_accordian_active').find('.rcpo_accordian_para').slideToggle('medium','linear');
      $(this).parents('.rcpo_accordian_data').siblings('.rcpo_accordian_active').removeClass('rcpo_accordian_active');
      $(this).parents('.rcpo_accordian_data').addClass('rcpo_accordian_active');
      $(this).siblings('.rcpo_accordian_para').slideToggle('medium','linear');
    }
  });
  
  //Breadcrumbs
  $('.template_collection_bespoke').bind('DOMNodeInserted DOMNodeRemoved', function(event) {
    // if($('.breadcrumbs .items li.cms_page').text().trim()== "") {
    //   $('.breadcrumbs .items li.cms_page').prev().addClass('blank_li_cms');
    // } else {
    //   $('.breadcrumbs .items li.cms_page').prev().removeClass('blank_li_cms');
    // }
  });

  // V12 modal popup
  $('.v12_badge').on('click', function(){
    //$('.v12_overlay').removeClass('hidden');
    var dataPrice = $(this).attr('data-price');
    $('input#cashPrice').val(dataPrice);
      $('input#cpRange').val(dataPrice);
      
      setTimeout(function() {
        $('#lowestMonthlyPayments a').trigger('click');
        $('select#productsList').val(30);
        $('.v12_overlay').removeClass('hidden');
      }, 500);
  });

  $('.close_button a').on('click', function(){
    $('.v12_overlay').addClass('hidden');
    $('input#depRange, input#deposit').val(10);
    $('span#deposit_percent').text('10');
  });

  $('.ProductItem__PriceList').on('click', '.installment', function(){
    var dataPrice = $(this).attr('data-price');
    $('input#cashPrice, input#cpRange').val(dataPrice);
    console.log(dataPrice+" jhfgjfjhgfjhg");
    if(dataPrice >= 300 && dataPrice < 500){
      $('input#deposit, input#depRange').val(35);
      $('input#depRange').attr('max', 35);
    }else{
      $('input#deposit, input#depRange').val(50);
      $('input#depRange').attr('max', 99);
    }
    $('.v12_overlay').removeClass('hidden');
  });
  
});  

jQuery(document).ready(function($){
  // Watch grid load more option
  $(function () {
      $("div.v7_watch_grid_loadmore").slice(0, 6).removeClass('hidden');
      $("#loadMore").on('click', function (e) {
        console.log('clicked');
          //e.preventDefault();
          $("div.v7_watch_grid_loadmore:hidden").slice(0, 6).slideDown('slow');
          if ($("div.v7_watch_grid_loadmore:hidden").length == 0) {
              $("#loadMore").fadeOut('slow');
          }
      });
  });
  // Watch grid rank sorting option
  $('.v7_watch_grid').each(function(e) {
    var divList = $(this).find(".v7_watch_grid_product");
    divList.sort(function(a, b){ return $(b).data("listing-rank")-$(a).data("listing-rank")});
    $(this).find(".v7_watch_grid_inner").html(divList);
    divList = '';
  });

  setTimeout(function () {
       $('a#imega-see-info').text('Finance Calculator');
   }, 2500);
  });

//Appointment Calender
const currentDate = new Date();
const twomonth = new Date(currentDate.getFullYear(), currentDate.getMonth()+2, currentDate.getDate());
console.log(twomonth);
var app_loc = 'windsor';
var initial_loop = 0;
var end_loop = 7;
var initialDates = getWeekDates(initial_loop,end_loop,currentDate);
$(".next_step_five").on('click', function (e) {
  e.preventDefault();
  app_loc = $('input[name="pos_address"]:checked').val();
  if(app_loc == 'ipswich') {
    initial_loop = 1;
    end_loop = 6;
    initialDates = getWeekDates(initial_loop,end_loop,currentDate);
    updateWeekLabel(initialDates[0].fullDate, initialDates[4].fullDate);
  } else {
    initial_loop = 0;
    end_loop = 7;
    initialDates = getWeekDates(initial_loop,end_loop,currentDate);
    updateWeekLabel(initialDates[0].fullDate, initialDates[6].fullDate);
  }
  checkButtonState(initialDates[0].fullDate);
  load_dates(initialDates);
}); 


function getWeekDates(initial_loop,end_loop,baseDate) {
  const start = new Date(baseDate);
  start.setDate(baseDate.getDate() - baseDate.getDay() + 1);
  const dates = [];
  for (let i = initial_loop; i < end_loop; i++) {
    const nextDay = new Date(start);
    nextDay.setDate(start.getDate() + i),
    dates.push({
      fullDate: nextDay,
      displayDate: formatDateToString(nextDay),
      displayDateN: formatDateToString2(nextDay),
      dayOfWeek: nextDay.toLocaleString("en-GB", { weekday: "short" }),
      dayOfMonth: nextDay.getDate(),
      isPast: nextDay <= new Date(),
    });
  }
  return dates;
}
function formatDateToString(date) {
    const day = date.getDate().toString().padStart(2, "0"),
        month = (date.getMonth() + 1).toString().padStart(2, "0"),
        year = date.getFullYear();
    return `${day}/${month}/${year}`;
}
function formatDateToString2(date) {
    const day = date.getDate().toString().padStart(2, "0"),
        month = (date.getMonth() + 1).toString().padStart(2, "0"),
        year = date.getFullYear();
    return `${year}-${month}-${day}`;
}
function updateWeekLabel(startDate, endDate) {
    const startDay = startDate.getDate(),
    startMonth = startDate.toLocaleDateString("en-GB", { month: "long" }),
    startYear = startDate.getFullYear(),
    endDay = endDate.getDate(),
    endMonth = endDate.toLocaleDateString("en-GB", { month: "long" });
    $("#v7_week_label").text(startDay + "-" + endDay + " " + startMonth + " " + startYear);
}
function updateWeek(direction) {
    //$("#timeslots .row").empty(), $(".timeslot-container").hide(), currentDate.setDate(currentDate.getDate() + direction * 7);
    currentDate.setDate(currentDate.getDate() + direction * 7);
    var weekDatescheck = getWeekDates(0,7,new Date(currentDate));
    if(app_loc == 'ipswich') {
      initial_loop = 1;
      end_loop = 6;
      
      var weekDates = getWeekDates(initial_loop,end_loop,new Date(currentDate));
      //initialDates = getWeekDates(initial_loop,end_loop,currentDate);
      updateWeekLabel(weekDates[0].fullDate, weekDates[4].fullDate);
    } else {
      initial_loop = 0;
      end_loop = 7;
      var weekDates = getWeekDates(initial_loop,end_loop,new Date(currentDate));
      updateWeekLabel(weekDates[0].fullDate, weekDates[6].fullDate);
    }
    //const weekDates = getWeekDates(new Date(currentDate));
    //preloadSlots(weekDates, currentDate), 
    checkButtonState(weekDates[0].fullDate);
    load_dates(weekDates)
    if(twomonth <= weekDatescheck[6].fullDate) {
      $("#v7_next_week").toggleClass("disabled");
    }
}
function checkButtonState(startDate) {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    const startOfWeek = new Date(startDate);
    $("#v7_prev_week").toggleClass("disabled", startOfWeek <= now);
    $("#v7_next_week").removeClass("disabled");
}
function load_dates(initialdate) {
    const $weekdaysRow = $("#v7_weekdays").empty();
    const data = initialdate;
    var html = '';
    $.each(initialdate, function(key, value) {
      html += "<div class='v7_weekday' data-date='"+value.displayDateN+"' data-current-date='" + value.displayDate + "' data-past='" + value.isPast + "'><span>" + value.dayOfWeek + "</span><span>" + value.dayOfMonth + "</span></div>";
    });
    $("#v7_weekdays").append(html);
};
function showLoader() {
    $(".loader").removeClass("hidden");
};
function hideLoader() {
    $(".loader").addClass("hidden");
}

jQuery(document).ready(function($){
  $("#v7_next_week").on('click', function (e) {
    e.preventDefault(), $(this).hasClass("disabled") || updateWeek(1);
  });
  
  $("#v7_prev_week").on('click', function (e) {
    e.preventDefault(), $(this).hasClass("disabled") || updateWeek(-1);
  });
  
});
//Appointment Calender End

var acc = document.getElementsByClassName("product__accordion");
var i;

for (i = 0; i < acc.length; i++) {

  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
    
  }); 
  
}

const desc = document.getElementById("description");
const specs = document.getElementById("specs");

desc.classList.add('active');

specs.classList.add('active'); 

const desc_val = desc.nextElementSibling;

desc_val.style.maxHeight = desc_val.scrollHeight + "px";

const spec_val = specs.nextElementSibling;

spec_val.style.maxHeight = spec_val.scrollHeight + "px";
